module.exports = "<p>multi-search-select works!</p>\n"